import React from 'react'
import CSSModules from 'react-css-modules'

import config from 'config'
import Iframe from '../iframe'
import styles from './lesson_preview_iframe.scss'

const lessonIframe = props => {

	let src = config.app+'?pin='+props.entityUID+'&sf='+props.sf
	if (props.bundleId) {
		src+='&bundleId='+props.bundleId
	}
	if (props.fromWelcome) {
		src+='&fw=true'
	}
	if (props.privateLibraryId) {
		src+='&plId='+props.privateLibraryId
	}

	return (
		<div styleName='preview-container'>
			{props.entityUID && <Iframe src={src} autoplay={true}/>}
		</div>
	)
}

lessonIframe.defaultProps = {
	sf: true,
}

export default CSSModules(lessonIframe, styles, {allowMultiple: true})
